import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import moment from 'moment';
import logo from '@assets/images/logo-therapia.png';

export const useFileExport = () => {
    async function reportConciliationPreparedExcel( lista: any , startDate: any , endDate: any , user:any  ) {
        const getLastLiberationDate = ( items: any[] ) => {
            if (!items || items.length === 0) return '';
            const sorted = items
                .filter(item => item.liberationDate)
                .sort((a, b) => new Date(b.liberationDate).getTime() - new Date(a.liberationDate).getTime());
            return sorted.length > 0 ? moment( sorted[0].liberationDate ).utc().format('DD/MM/yyyy HH:mm') : '';
        }

        const dataList = lista;
        const totalPrepared = lista.reduce((sum: number, group: any) => sum + (group.items?.length || 0), 0);
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Conciliación de Preparados');
        const columnWidths = [ 63 , 22 , 22 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE CONCILIACIÓN DE PREPARADOS POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['CANTIDAD INSTITUCIONES SEGÚN RANGO DE FECHA:' , lista.length];
        row8.getCell(1).alignment = { horizontal:'left' }
        const row9 = sheet.getRow(9);
        row9.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row9.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);
        row11.values = ['Nombre Institución' , 'Cantidad' , 'Última Hora Liberación'];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [ item.items[0].organizationName , item.count , getLastLiberationDate( item.items ) ];
            row.getCell(1).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ConciliaciónPreparados-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportConciliationPatientExcel( lista: any , startDate: any , endDate: any , user:any  ) {
        const dataList = lista.flatMap((group: any) => group.items);
        const totalPrepared = lista.reduce((sum: number, group: any) => sum + group.count, 0);
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Conciliación de Pacientes');
        const columnWidths = [ 63 , 16 , 45 , 30 , 16 , 30 , 22 , 22 , 22 , 22 , 22 , 22 , 22 , 40 , 32 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE CONCILIACIÓN DE PACIENTES POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['CANTIDAD INSTITUCIONES SEGÚN RANGO DE FECHA:' , lista.length];
        row8.getCell(1).alignment = { horizontal:'left' }
        const row9 = sheet.getRow(9);
        row9.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row9.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);
        row11.values = ['Nombre paciente' , 'Identificación' , 'Institución' , 'Preparado' , 'Dosis' , 'Vol Vehículo' , 'Laboratorio' , 'Lote' , 'Fecha administración' , 'Hora preparación' , 'Hora liberación' , 'Hora de etiquetado' , 'Condición de almacenamiento' , 'Liberado por'];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11' , 'I11' , 'J11' , 'K11' , 'L11' , 'M11' , 'N11' ].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });         
        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                item.patient.fullName ,
                item.patient.rut || item.patient.passport || item.patient.sheet ,
                item.organizationName || '' ,
                item.medications.drugName || '' ,
                `${item.medications.dose} mg` || '' ,
                `${item.medications.solutionName} ${item.medications.solutionVolume}` || '' ,
                item.medications.laboratorySelected ? item.medications.laboratorySelected.name : '' ,
                `${item.medications.batch1} ${item.medications.batch2 ?  '-' + item.medications.batch2 : ''}` ,
                item.medications.administrationDate ? moment.utc(item.medications.administrationDate).format('DD/MM/yyyy') : '' ,
                item.productionDate ? moment.utc(item.labeledDate).format('DD/MM/yyyy HH:mm') : '' ,
                item.liberationDate ? moment.utc(item.liberationDate).format('DD/MM/yyyy HH:mm') : '' ,
                item.validationDate ? moment.utc(item.validationDate).format('DD/MM/yyyy HH:mm') : '' ,
                item.medications?.presentationSelected?.drugStorageConditions ? Number(item.medications?.presentationSelected?.drugStorageConditions) === 1 ? 'NO REFRIGERAR' : 'REFRIGERAR' : '' ,
                (() => {
                    if (item.liberationUser) {
                        return `${item.liberationUser.given_name} ${item.liberationUser.family_name}`;
                    }
                    const filtered = item.historyStatus?.filter((h: any) => h.status === 'Enviado a Facturación') || [];
                    const last = filtered.length > 0 ? filtered[filtered.length - 1] : null;
                    return last ? `${last.user.given_name} ${last.user.family_name}` : '';
                })()
            ];
            row.getCell(1).alignment = { horizontal: 'left' };
            row.getCell(2).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ConciliaciónPacientes-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportConciliationStoreExcel( lista: any , totalPrepared: number ,  startDate: any , endDate: any , user:any  ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Conciliación de Bodega');
        const columnWidths = [ 22 , 45 , 22 , 16 , 30 , 22 , 45 , 45 , 22 , 22 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE CONCILIACIÓN DE BODEGA POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);
        row11.values = ['N° Campaña' , 'Preparado' , 'Ley Ricarte Soto' , 'Presentación' , 'Laboratorio' , 'N° Frascos' , 'Institución' , 'Origen droga' , 'Fecha y hora' , 'Responsable ingreso'];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 'I11', 'J11'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const calculateDose = (item: any) => {
            const pres = Number(item.medications?.presentationSelected?.drugPresentation);
            const dose = Number(item.medications?.dose) || 0;
            if (!pres || pres === 0) return 0;
            const result = Math.ceil(dose / pres);
            return isNaN(result) ? 0 : result;
        }

        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                item.campaingId ,
                item.medications.drugName ,
                item.medications.isRicarteSoto ? 'Sí' : 'No' ,
                item.medications.presentationSelected ? `${item.medications.presentationSelected.drugPresentation} ${item.medications.presentationSelected.drugPreUnit}` : '' ,
                item.medications.laboratorySelected ? item.medications.laboratorySelected.name : '' ,
                calculateDose(item) ,
                item.organizationName ,
                item.medications.originDrugSelected ? item.medications.originDrugSelected.name : '' ,
                '' ,
                '' ,
                ''
            ];
            row.getCell(1).alignment = { horizontal: 'left' };
            row.getCell(2).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ConciliaciónBodega-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportInstitutionalApplicationsExcel( lista: any , totalPrepared: number ,  startDate: any , endDate: any , user:any  ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Reporte Solicitudes Institucionales');
        const columnWidths = [ 22 , 45 , 22 , 16 , 30 , 22 , 22 , 22 , 30 , 30 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE SOLICITUDES INSTITUCIONALES'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);

        row11.values = ['Rut' , 'Nombre Paciente' , 'Protocolo' , 'Preparado' , 'Dosis' , 'Servicio' , 'Administración' , 'Envío de receta' , 'Médico' , 'Estado Solicitud'];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 'I11', 'J11'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            const enviadaStatus = item.historyStatus?.find( ( h: any ) => h.status === 'Enviada' );
            const enviadaDate = enviadaStatus ? moment.utc( enviadaStatus.date ).format('DD/MM/YYYY') : '-';
            row.values = [
                item.patient.rut || '' ,
                item.patient.fullName || '' ,
                item.treatment.treatmentProtocol || '' ,
                item.medications.drugName || '' ,
                `${item.medications.dose} mg` || '' ,
                item.treatment.service ,
                item.medications.administrationDate ? moment.utc( item.medications.administrationDate ).format('DD/MM/YYYY') : '' ,
                enviadaDate ,
                item.doctor.fullName ,
                `${item.currentStageName} - ${item.status}`
            ];
            row.getCell(1).alignment = { horizontal: 'left' };
            row.getCell(2).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ReporteSolicitudesInstitucionales-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportAutorizationExcel( lista: any , totalPrepared: number ,  startDate: any , endDate: any , user:any  ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Reporte Autorización');
        const columnWidths = [ 45 , 45 , 22 , 30 , 36 , 30 , 22 , 22 , 36 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE AUTORIZACIÓN'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);
        row11.values = [ 'Nombre Paciente' , 'Preparado' , 'Dosis' , 'Vol Vehículo' , 'Institución' , 'Origen droga' , 'Administración' , 'Envío a elaboración' , 'Estado' ];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 'I11'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                item.patient.fullName || '' ,
                item.medications.drugName || '' ,
                `${item.medications.dose} mg` || '' ,
                `${item.medications.solutionName} ${item.medications.solutionVolume}` || '' ,
                item.organizationName || '' ,
                item.medications.originDrugSelected ? item.medications.originDrugSelected.name : '' ,
                item.medications.administrationDate ? moment.utc(item.medications.administrationDate).format('DD/MM/yyyy') : '' ,
                item.pickingDate ? moment.utc(item.pickingDate).format('DD/MM/yyyy HH:mm') : '' ,
                `${item.currentStageName} - ${item.status}`
            ];
            row.getCell(1).alignment = { horizontal: 'left' };
            row.getCell(2).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ReporteAutorización-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }


    async function reportInventoryManagementExcel( lista: any , totalPrepared: number , startDate: any , endDate: any , user:any  ) {
        const groupItemsWithCount = (items: any) => {
            const grouped = items.reduce((acc: any, item: any) => {
                const key = [
                    item.organizationName,
                    item.medications.originDrugSelected.name,
                    item.medications.drugName,
                    item.medications.presentationSelected.drugPresentation,
                    item.medications.presentationSelected.drugPreUnit,
                    item.medications.laboratorySelected.name,
                    item.medications.isRicarteSoto,
                    item.campaingId
                ].join('|');
        
                if (!acc[key]) {
                    acc[key] = {
                        organizationName: item.organizationName,
                        originDrug: item.medications.originDrugSelected.name,
                        drugName: item.medications.drugName,
                        presentation: item.medications.presentationSelected.drugPresentation,
                        drugPreUnit: item.medications.presentationSelected.drugPreUnit,
                        laboratory: item.medications.laboratorySelected.name,
                        campaingId: item.campaingId,
                        isRicarteSoto: item.medications.isRicarteSoto,
                        totalUnits: 0,
                        elements: []
                    };
                }
        
                acc[key].totalUnits += item.medications.units || 1;
                acc[key].elements.push(item);
        
                return acc;
            }, {});
            return Object.values(grouped);
        };
        const calculateDoseLocal = ( elementos: any[] , presentation: any ) => {
            const pres = Number( presentation );
            const sumaDose = elementos.reduce((acc, elemento) => {
                return acc + (Number(elemento.medications.dose) || 0);
            }, 0);
            if (pres === 0) return 0;
            const result = sumaDose / pres;
            return Math.ceil(result);
        }

        const dataList: any = groupItemsWithCount(lista);

        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Gestión de Inventarios');
        const columnWidths = [ 20 , 35 , 20 , 35 , 35 , 35 , 35, 35, 35 , 35 , 35 , 35 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE GESTIÓN DE INVENTARIOS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row10 = sheet.getRow(10);
        row10.values = ['Campaña' , 'Preparado' , 'Ley Ricarte Soto' , 'Presentación', 'Laboratorio', 'N° Frascos' , 'Institución' , 'Origen de Droga' , 'Fecha y Hora' , 'Responsable ingreso' , 'Responsable salida' ];
        row10.font = { bold: true };
        row10.alignment = { horizontal: 'center' };
        [ 'A10', 'B10', 'C10' , 'D10', 'E10', 'F10' , 'G10' , 'H10', 'I10', 'J10' , 'K10' ].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        
        const rowsToInsert: any = sheet.getRows( 11 , dataList.length );
        
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                item.campaingId ,
                item.drugName ,
                item.isRicarteSoto ? 'Sí' : 'No' ,
                `${item.presentation} ${item.drugPreUnit}` ,
                item.laboratory ,
                calculateDoseLocal( item.elements , item.presentation ) ,
                item.organizationName ,
                item.originDrug,
                item.elements[0].generationDate ? moment.utc(item.elements[0].generationDate).format('DD/MM/YYYY HH:mm') : '' ,
                (() => {
                    const responsible = item.elements[0].historyStatus.find( (el: any) => el.status === 'Enviado a Bodega' && el.currentStage === 'stage1' );
                    return responsible ? `${responsible.user.given_name} ${responsible.user.family_name}` : '';
                })(),
                (() => {
                    const responsible = item.elements[0].historyStatus.find( (el: any) => el.status === 'Enviado a Picking' && el.currentStage === 'stage2' );
                    return responsible ? `${responsible.user.given_name} ${responsible.user.family_name}` : '';
                })()

            ];
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `GestiónInventarioResumen-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportInventoryManagementListExcel( lista: any , totalPrepared: number , startDate: any , endDate: any , user:any  ) {
        const dataList: any = lista;

        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Gestión de Inventarios');
        const columnWidths = [ 20 , 35 , 35 , 35 , 35 , 35, 35, 35 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE GESTIÓN DE INVENTARIOS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['TOTAL PREPARADOS:' , totalPrepared];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row10 = sheet.getRow(10);
        row10.values = ['Número' , 'Droga' , 'Presentación', 'Laboratorio', 'Dosis' , 'Institución' , 'Origen de Droga' , 'Fecha' ];
        row10.font = { bold: true };
        row10.alignment = { horizontal: 'center' };
        [ 'A10', 'B10', 'C10' , 'D10', 'E10', 'F10' , 'G10' , 'H10' ].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 11 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                index + 1 ,
                item.medications.drugName ,
                `${item.medications.presentationSelected.drugPresentation} ${item.medications.presentationSelected.drugPreUnit}` ,
                item.medications.laboratorySelected.name ,
                item.medications.dose ,
                item.organizationName ,
                item.medications.originDrugSelected.name,
                item.pickingDate ?  moment.utc(item.pickingDate).format('DD/MM/YYYY HH:mm') : '-'
            ];
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `GestiónInventarioRegistro-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportDetectionsExcel( lista: any , totalPrepared: number ,  startDate: any , endDate: any , user:any  ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Detecciones');
        const columnWidths = [ 25 , 42 , 28 , 28 , 22 , 22 , 22 , 40 , 75 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        
        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE DETECCIONES POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['CANTIDAD DE REGISTROS:' , lista.length];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);
        row11.values = [ 'Número' , 'Nombre Paciente' , 'Droga' ,  'Nombre Institución' , 'Estado' , 'Acción' , 'Área' , 'Observación' , 'Clasificación' ];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11' , 'D11' , 'E11' , 'F11' , 'G11' , 'H11' , 'I11' ].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 12 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                index + 1 ,
                item.patient.fullName ,
                item.medications.drugName ,
                item.organizationName ,
                item.status ,
                item.isReturned.action ,
                item.isReturned.area ,
                item.isReturned.observation ,
                item.isReturned.classification ,
            ];
            row.getCell(8).alignment = { horizontal: 'left' };
            row.getCell(9).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `Detecciones-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    async function reportApplicationList( lista: any , totalPrepared: number ,  startDate: any , endDate: any , user:any  ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Listado de Solicitudes');
        const columnWidths = [ 22 , 45 , 22 , 16 , 30 , 22 , 45 , 45 , 22 , 30 ]
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } )

        sheet.columns.forEach( column => {          
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['REPORTE DE LISTA DE SOLICITUDES POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal:'left' }
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal:'left' }
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal:'left' }
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal:'left' }
        const row8 = sheet.getRow(8);
        row8.values = ['CANTIDAD DE REGISTROS:' , lista.length];
        row8.getCell(1).alignment = { horizontal:'left' }

        const row11 = sheet.getRow(11);

        row11.values = ['Rut' , 'Nombre Paciente' , 'Protocolo' , 'Preparado' , 'Dosis' , 'Servicio' , 'Administración' , 'Envío de receta' , 'Médico' , 'Estado Solicitud'];
        row11.font = { bold: true };
        row11.alignment = { horizontal: 'center' };
        ['A11', 'B11', 'C11', 'D11', 'E11', 'F11', 'G11', 'H11', 'I11', 'J11'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const totalRows = dataList.reduce( ( acc: number , item: any ) => {
            const meds = Array.isArray( item.medications ) ? item.medications : [ item.medications ];
            return acc + meds.length;
        } , 0 );

        const rowsToInsert: any = sheet.getRows( 12 , totalRows );
        let rowIndex = 0;
        dataList.forEach( ( item: any ) => {
            const meds = Array.isArray( item.medications ) ? item.medications : [ item.medications ];
            meds.forEach( ( med: any , medIndex: number ) => {
                const row = rowsToInsert[ rowIndex ];
                const enviadaStatus = med.historyStatus?.find( ( h: any ) => h.status === 'Enviada' );
                const enviadaDate = enviadaStatus ? moment.utc( enviadaStatus.date ).format('DD/MM/YYYY') : '-';
                if ( medIndex === 0 ) {
                    row.values = [
                        item.patient.rut || '' ,
                        item.patient.fullName || '' ,
                        item.treatment.treatmentProtocol || '' ,
                        med.drugName || '' ,
                        `${med.dose} mg` || '' ,
                        item.treatment.service ,
                        med.administrationDate ? moment.utc( med.administrationDate ).format('DD/MM/YYYY') : '' ,
                        enviadaDate ,
                        item.doctor.fullName ,
                        `${item.currentStageName} - ${item.status}`
                    ];
                } else {
                    row.values = [
                        '' , '' , '' ,
                        med.drugName || '' ,
                        `${med.dose} mg` || '' ,
                        '' ,
                        med.administrationDate ? moment.utc( med.administrationDate ).format('DD/MM/YYYY') : '' ,
                        enviadaDate ,
                        '' ,
                        ''
                    ];
                }
                row.getCell(1).alignment = { horizontal: 'left' };
                row.getCell(2).alignment = { horizontal: 'left' };
                rowIndex++;
            } );
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `ListadoSolicitudes-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }
    
    async function reportISPExcel( lista: any , startDate: any , endDate: any , user: any ) {
        const dataList = lista;
        const workbook = new Workbook();
        workbook.creator = 'Fresenius Kabi';
        const sheet = workbook.addWorksheet('Informe ISP');
        const columnWidths = [ 20 , 40 , 40 , 22 , 22 , 60 ];
        columnWidths.forEach( ( width , index ) => {
            sheet.getColumn(index + 1).width = width;
        } );

        sheet.columns.forEach( column => {
            column.alignment = { ...column.alignment , vertical: 'middle', wrapText: false , horizontal: 'center' };
        } );

        const imageResponse = await fetch(logo);
        const imageBlob = await imageResponse.blob();
        const imageArrayBuffer = await imageBlob.arrayBuffer();

        const imageId = workbook.addImage({
            buffer: imageArrayBuffer,
            extension: 'png',
        });

        sheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 200, height: 54 },
        });

        const row4 = sheet.getRow(4);
        row4.values = ['INFORME ISP POR RANGO DE FECHAS'];
        row4.getCell(1).alignment = { horizontal: 'left' };
        const row5 = sheet.getRow(5);
        row5.values = ['FECHA INICIO:' , moment(startDate).utc().format('DD/MM/YYYY')];
        row5.getCell(1).alignment = { horizontal: 'left' };
        const row6 = sheet.getRow(6);
        row6.values = ['FECHA TÉRMINO:' , moment(endDate).utc().format('DD/MM/YYYY')];
        row6.getCell(1).alignment = { horizontal: 'left' };
        const row7 = sheet.getRow(7);
        row7.values = ['USUARIO:' , `${user.given_name} ${user.family_name}`];
        row7.getCell(1).alignment = { horizontal: 'left' };
        const row8 = sheet.getRow(8);
        row8.values = ['CANTIDAD DE REGISTROS:' , lista.length];
        row8.getCell(1).alignment = { horizontal: 'left' };

        const row10 = sheet.getRow(10);
        row10.values = ['Folio' , 'Institución' , 'Nombre Paciente' , 'Administración' , 'Elaboración' , 'Medicamento'];
        row10.font = { bold: true };
        row10.alignment = { horizontal: 'center' };
        ['A10', 'B10', 'C10', 'D10', 'E10', 'F10'].forEach((cellRef) => {
            const cell = sheet.getCell(cellRef);
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD9D9D9' },
            };
        });

        const rowsToInsert: any = sheet.getRows( 11 , dataList.length );
        rowsToInsert.forEach( ( row: any , index: number ) => {
            const item = dataList[index];
            row.values = [
                item.RM ,
                item.organizationName || '-' ,
                item.patient?.fullName || '-' ,
                moment.utc(item.medications?.administrationDate).format('DD/MM/YYYY') ,
                moment.utc(item.elaborationDate).format('DD/MM/YYYY') ,
                `${item.medications?.drugName} ${item.medications?.dose} mg + ${item.medications?.solutionName} ${item.medications?.solutionVolume} ml`
            ];
            row.getCell(1).alignment = { horizontal: 'center' };
            row.getCell(2).alignment = { horizontal: 'left' };
            row.getCell(3).alignment = { horizontal: 'left' };
            row.getCell(6).alignment = { horizontal: 'left' };
        } );

        workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob( [buffer] );
            fs.saveAs(blob , `informe-isp-${moment(startDate).utc().format('DD-MM-YYYY')}-al-${moment(endDate).utc().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    return {
        reportConciliationPreparedExcel ,
        reportConciliationPatientExcel ,
        reportConciliationStoreExcel ,
        reportInstitutionalApplicationsExcel ,
        reportAutorizationExcel ,
        reportInventoryManagementExcel ,
        reportInventoryManagementListExcel ,
        reportDetectionsExcel ,
        reportApplicationList ,
        reportISPExcel
    };
};
